import { createSlice } from '@reduxjs/toolkit';

const initialState = { advSearchObj: {}, initialParams: {} };

const HighlightSlice = createSlice({
  name: 'Highlight',
  initialState: initialState,
  reducers: {
    setHighlightFilter: (state, action) => {
      const { advSearch, params } = action.payload || {};
      if (advSearch) {
        const cleanedSearch = Object.keys(advSearch).reduce((acc, key) => {
          if (advSearch[key] !== undefined) {
            acc[key] = advSearch[key];
          }
          return acc;
        }, {});
        state.advSearchObj = cleanedSearch;
      }
      if (params) {
        state.initialParams = params;
      }
    },
    resetHighlightFilter: () => initialState,
  },
});

export const { setHighlightFilter, resetHighlightFilter } =
  HighlightSlice.actions;
export default HighlightSlice.reducer;
